import EL, { HTMLELEMENT } from '../../EL/EL.js';
/** A top level Main View that holds all other child Containers */
export default class MAIN extends EL {
    constructor(node, model) {
        super(node, HTMLELEMENT.MAIN, model);
    }
}
export { EL };
